(function () {
  function addLines() {
    document.querySelectorAll('.product-info .opt-label--swatch, .product-info .opt-label--image').forEach(function (l) {
      if (l.querySelector('.pdp-ul')) return;
      var s = document.createElement('span');
      s.className = 'pdp-ul';
      s.setAttribute('aria-hidden', 'true');
      l.appendChild(s);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addLines);
  else addLines();
  document.addEventListener('shopify:section:load', addLines);
  document.addEventListener('change', function () { setTimeout(addLines, 50); });

  /* ---------- Price on the Add to Kit button ("$48 — ADD TO KIT") ---------- */
  var syncing = false;
  function currentPrice() {
    var p = document.querySelector('.product-info .product-info__price');
    if (!p) return '';
    var c = p.cloneNode(true);
    c.querySelectorAll('s, del, [class*="compare"], [class*="was"], .visually-hidden, [class*="sr-only"]').forEach(function (n) { n.remove(); });
    var m = (c.textContent || '').replace(/\s+/g, ' ').match(/[$€£]\s?[\d.,]+/);
    return m ? m[0].replace(/\s/g, '') : '';
  }
  function syncButton() {
    if (syncing) return;
    var btn = document.querySelector('.product-info .product-add .btn--primary, .product-info .product-add button[type="submit"], .product-info .product-info__block--buy-buttons button[type="submit"]');
    if (!btn) return;
    syncing = true;
    var span = btn.querySelector('.pdp-btn-price');
    var price = currentPrice();
    var disabled = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
    if (!price || disabled) {
      if (span) span.remove();
    } else {
      if (!span) {
        span = document.createElement('span');
        span.className = 'pdp-btn-price';
        btn.insertBefore(span, btn.firstChild);
      }
      var t = price + ' — ';
      if (span.textContent !== t) span.textContent = t;
    }
    syncing = false;
  }
  function watchButton() {
    syncButton();
    var root = document.querySelector('.product-info');
    if (!root || root.dataset.pdpBtnWatch) return;
    root.dataset.pdpBtnWatch = '1';
    new MutationObserver(function () { setTimeout(syncButton, 0); }).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    document.addEventListener('change', function () { setTimeout(syncButton, 120); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchButton);
  else watchButton();
  document.addEventListener('shopify:section:load', watchButton);

  /* ---------- Size chart drawer (loads the Size Guide page) ---------- */
  var css = document.createElement('style');
  css.textContent =
    '.sc-overlay{position:fixed;inset:0;z-index:2147483000;background:rgba(255,255,255,.28);-webkit-backdrop-filter:blur(14px);backdrop-filter:blur(14px);opacity:0;pointer-events:none;transition:opacity .25s ease}' +
    '.sc-overlay.is-open{opacity:1;pointer-events:auto}' +
    '.sc-drawer{position:fixed;top:0;right:0;bottom:0;z-index:2147483001;width:480px;max-width:100vw;background:#fff;color:#000;border-left:1px solid #ebebeb;transform:translateX(100%);transition:transform .3s ease;display:flex;flex-direction:column}' +
    '.sc-drawer.is-open{transform:none}' +
    '.sc-head{display:flex;align-items:center;justify-content:space-between;padding:14px 28px;border-bottom:1px solid #ebebeb;font-size:15px;font-weight:500}' +
    '.sc-close{background:none;border:0;padding:6px;margin:-6px;cursor:pointer;font-size:22px;line-height:1;color:#000}' +
    '.sc-body{flex:1;overflow-y:auto;padding:12px 28px 56px;font-size:13px;line-height:1.5}' +
    '.sc-body > div{max-width:none !important;margin:0 !important}' +
    '.sc-body h1{display:none !important}' +
    '.sc-body > div > p:first-of-type{display:none !important}' +
    '.sc-body > div > p:nth-of-type(2){margin:16px 0 8px !important;font-size:12px !important;font-style:normal !important;color:#737373 !important;line-height:1.6 !important}' +
    '.sc-body h2{margin:36px 0 4px !important;font-size:12px !important;font-weight:600 !important;letter-spacing:.08em !important}' +
    '.sc-body h3{margin:22px 0 6px !important;font-size:11px !important;font-weight:500 !important;letter-spacing:.06em !important;text-transform:uppercase !important;color:#737373 !important}' +
    '.sc-body table{width:100% !important;margin:0 0 8px !important;border:0 !important;border-collapse:collapse !important;table-layout:auto}' +
    '.sc-body th,.sc-body td{border:0 !important;border-bottom:1px solid #efefef !important;background:none !important;padding:13px 8px 13px 0 !important;text-align:left !important;font-size:13px !important;font-weight:400 !important;color:#000 !important;white-space:nowrap}' +
    '.sc-body th{padding-top:6px !important;padding-bottom:10px !important;border-bottom:1px solid #000 !important;font-size:10px !important;font-weight:500 !important;letter-spacing:.07em !important;text-transform:uppercase !important;color:#737373 !important;white-space:normal}' +
    '.sc-body td:first-child{font-weight:600 !important}' +
    '.sc-body tr:last-child td{border-bottom:0 !important}' +
    '.sc-body hr{border:0 !important;border-top:1px solid #ebebeb !important;margin:32px 0 0 !important}' +
    '.sc-body ul{margin:10px 0 0 !important;padding:0 !important;list-style:none !important}' +
    '.sc-body li{margin:0 0 10px !important;font-size:12px !important;line-height:1.6 !important;color:#404040}' +
    '.sc-body li strong{color:#000;font-weight:600}' +
    '.sc-body p{font-size:12px !important;line-height:1.6 !important}';
  document.head.appendChild(css);

  var overlay, drawer, body, loaded = false;
  function build() {
    if (drawer) return;
    overlay = document.createElement('div'); overlay.className = 'sc-overlay';
    drawer = document.createElement('div'); drawer.className = 'sc-drawer';
    drawer.setAttribute('role', 'dialog'); drawer.setAttribute('aria-label', 'Size chart');
    drawer.innerHTML = '<div class="sc-head"><span>Size Chart</span><button type="button" class="sc-close" aria-label="Close">&times;</button></div><div class="sc-body">Loading...</div>';
    body = drawer.querySelector('.sc-body');
    document.body.appendChild(overlay); document.body.appendChild(drawer);
    overlay.addEventListener('click', close);
    drawer.querySelector('.sc-close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }
  function close() { if (!drawer) return; overlay.classList.remove('is-open'); drawer.classList.remove('is-open'); }
  function open() {
    build();
    requestAnimationFrame(function () { overlay.classList.add('is-open'); drawer.classList.add('is-open'); });
    if (loaded) return;
    fetch('/pages/size-guide').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.querySelector('.page-content .rte, .rte, .page-content, main');
      body.innerHTML = el ? el.innerHTML : 'Size guide unavailable right now.';
      loaded = true;
    }).catch(function () { body.innerHTML = '<a href="/pages/size-guide">Open the size guide</a>'; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.size-chart-link');
    if (!b) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    open();
  }, true);
})();